export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.61499 15.1539C9.81545 17.4036 14.2434 17.0842 17.0954 14.1958C20.3019 10.9483 20.3019 5.6831 17.0954 2.43562C13.8889 -0.811872 8.6902 -0.811872 5.48372 2.43562C2.40019 5.55858 2.28196 10.5475 5.12903 13.8136L0.5 18.6108L1.93922 19.9996L6.61499 15.1539ZM15.6902 12.7726C13.2598 15.2341 9.31933 15.2341 6.88892 12.7726C4.45851 10.3111 4.45851 6.32028 6.88892 3.85878C9.31933 1.39729 13.2598 1.39729 15.6902 3.85878C18.1206 6.32028 18.1206 10.3111 15.6902 12.7726Z"/>
  `,
  title: 'Search',
};
